import * as React from 'react';
import { connect } from 'react-redux';
import { editPublicacion } from '../../../../actions/publicacionesActions';
import { fetchGarantias } from '../../../../actions/garantiasActions'
import GarantiaListItem from '../ABM/GarantiaListItem'
import Select from 'react-select';
import { customStyle } from '../../../../template/CustomStyle';
import { DropDownArrow } from "../../../../template/CustomStyle";
import { toast } from 'react-toastify';

class Garantia extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isCreated: true,
            garantiaExtActiva: this.props.publicacion.garantiaExtActiva,
            garantiaFabrica: {
                label: this.props.publicacion.garantiaFabrica,
                value: this.props.publicacion.garantiaFabrica
            }
        }
    };

    componentDidMount = () => {
        this.loadGarantias();
    }

    loadGarantias = () => {
        this.props.fetchGarantias({ codProducto: this.props.publicacion.skuMarket })
            .catch(error => {
                const msg = error.response?.data?.errores?.[0];
                if (msg) {
                    toast.error(msg);
                } else {
                    toast.error("Error al obtener garantías");
                }
            });
    }

    myChangeHandler = (event) => {
        let publicacion = { ...this.props.publicacion };
        if (event.target.name == "garantiaExtActiva") {
            publicacion[event.target.name] = !this.state.garantiaExtActiva;
            this.setState({ garantiaExtActiva: !this.state.garantiaExtActiva })
        }
        else {
            publicacion[event.target.name] = parseInt(event.target.value);
        }
        this.props.editPublicacion(publicacion);
    }

    handleGarantiaFabrica = (selectedOption) => {
        if (!selectedOption) return;
        this.setState({
            garantiaFabrica: {
                label: selectedOption.label,
                value: selectedOption.value
            }
        });
        let publicacion = { ...this.props.publicacion };
        publicacion["garantiaFabrica"] = selectedOption.value;
        this.props.editPublicacion(publicacion);
    }

    render() {
        const showDetails = this.props.userType.isAdminMod || this.props.userType.isCategory;
        const garantiaFabricaOptions = [
            { value: 0, label: "0 meses" },
            { value: 1, label: "1 mes" },
            { value: 3, label: "3 meses" },
            { value: 6, label: "6 meses" },
            { value: 12, label: "12 meses" },
            { value: 18, label: "18 meses" },
            { value: 24, label: "24 meses" },
            { value: 36, label: "36 meses" },
            { value: 60, label: "60 meses" },
            { value: 120, label: "120 meses" }
        ];

        return (
            <div className="tab-pane p-20 active" name="datos" id="home2" role="tabpanel">
                <div className="col-sm-12 col-md-6 col-lg-6">
                    <div>
                        <label>Garantía de fabrica</label>
                        <Select
                            name="garantiaFabrica"
                            options={garantiaFabricaOptions}
                            onChange={this.handleGarantiaFabrica}
                            value={this.state.garantiaFabrica}
                            components={{ DropdownIndicator: () => DropDownArrow }}
                            styles={customStyle}
                            placeholder=""
                        />
                    </div>

                    {showDetails && this.props.garantias.garantias
                        && this.props.garantias.garantias.map((garantia, i) => {
                            return (
                                <div className="list-group" key={i}>
                                    <a>
                                        <GarantiaListItem
                                            cantidadCuotas={garantia.cantidadCuotas}
                                            importe={garantia.valorCuota}
                                        />
                                    </a>
                                </div>
                            );
                        })
                    }
                </div>

                {showDetails &&
                    <div className="col-12 col-sm-6">
                        <label className="control-label">Estado</label>
                        <div className="custom-control form-switch">
                            <input
                                name="garantiaExtActiva"
                                type="checkbox"
                                id="switchEstado"
                                className="form-check-input"
                                checked={this.state.garantiaExtActiva}
                                onChange={this.myChangeHandler}
                            />
                            <label className="custom-control-label mx-1" htmlFor="switchEstado">
                                {this.state.garantiaExtActiva ? "Activa" : "Inactiva"}
                            </label>
                        </div>

                        <div className="form-group">
                            <label>Código de elegibilidad</label>
                            <input
                                disabled
                                type="string"
                                className="form-control"
                                name="codigoElegibilidad"
                                onChange={this.myChangeHandler}
                                value={this.props.publicacion.codigoLegibilidad}
                            />
                        </div>
                    </div>
                }
            </div>
        );
    }
}


const mapStateToProps = state => ({
    userType: state.general.userType,
    publicacion: state.publicaciones.publicacion,
    garantias: state.publicaciones.garantias,
});

export default connect(mapStateToProps, {
    fetchGarantias,
    editPublicacion,
})(Garantia);